import { observable } from "mobx";
import moment from "moment";

export default class CargaGeralCadastrarStore {

    @observable novaCarga;
    @observable navioSelecionadoAgend;
    @observable salvando;
    @observable msgEmail;

    constructor(editando) {
        if (editando) {
            this.novaCarga = editando;
        } else {
            this.navioSelecionadoAgend = false;
            this.regimeSelecionado = false
            this.novaCarga = {
                id: 0,
                Cnh: "",
                OperacaoId: "",
                Navio: "",
                Cpf: "",
                Motorista: "",
                Placa: "",
                Status: "",
                DtEntrada: "",
                DtCadastro: moment().format("YYYY-MM-DD[T]HH:mm:ss"),
                DtInativou: null,
                Observacao: "",
                UsuarioCadastro: "",
                UsuarioInativou: ""
            };
        }

        this.salvando = false;

        this.msgEmail = false;

        // this.service = new CabotagemService();
    };

  


    

    setNavio = (event) => {
        if (event)
            this.navioSelecionadoAgend = event
        else
            this.navioSelecionadoAgend = false;
    };

}


// WEBPACK FOOTER //
// ./src/modules/carga-geral/stores/CargaGeralCadastrarStore.js